export function assert(condition: unknown, msg?: string): asserts condition {
  if (condition === false) {
    throw new Error(msg);
  }
}

export function assertNotNull<T>(value: T | null): asserts value is Exclude<T, null> {
  assert(value !== null, "(assertNotNull): Expected a non-null value, but received null");
}

export function assertNotUndefined<T>(value: T | undefined): asserts value is Exclude<T, undefined> {
  assert(value !== undefined, "(assertNotUndefined): Expected a non-undefined value, but received undefined");
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function assertNotFunction<T>(value: T): asserts value is Exclude<T, Function> {
  assert(typeof value !== "function", "(assertNotFunction): Expected a primitive value, but received a function");
}

export function assertNonEmptyString(value?: string | null): asserts value is string {
  assert(
    typeof value === "string",
    "(assertNonEmptyString): Expected a non-empty string, but received null or undefined",
  );
  assert(value.trim() !== "", "(assertNonEmptyString): Expected a non-empty string, but received empty string");
}
